module.exports = __webpack_public_path__ + "static/services-cs-salesmate-003235d686f214f010e13a5d49fa32d5.png";